export const VSD_MOTOR_REQUEST = {
    SU_CALCULATESPEED_1LE1X: '1488',
    SU_SYNCSPEED_1LE1HK: '1500',
    JOM_MLFB_123: '1LE1603-3AB53-4AQ4',
    JOM_KAG_123: 'B43',
    JOM_LANG: 'en',
    SU_FREQUENCY_1LE1X: '50',
    SU_SUPPLYVOLTAGE_1LE1X: '400',
    SU_RATEDPOWER_1LE1X: '200.00',
    SU_CALCULATEPOWER_1LE1X: '200.00',
    SU_EFFICIENCYCLASS_1LE1HK: 'IE3',
    SU_VOLTAGECODE_1LE1HK: '34',
    SU_WINDING_1LE1HK: '400+VΔ+/+690+VY+50Hz,+460+VΔ+60Hz',
    PMD_AAD769_001_000_HK1LE: 'Cast iron',
    PMD_AAA726_001_000_HK1LE: '315L',
    PMD_AAA149_001_000_HK1LE: '4',
    PMD_AAF197_001_000_HK1LE: '39.30',
    PMD_AAF510_001_000_HK1LE: '69.30',
    PMD_ABV064_001_000_1010600: '25.10',
    PMD_ABV063_001_000_1010600: '44.30',
    PMD_ACN903_001_000_1LE7: '50.0',
    PMD_ACN904_001_000_1LE7: '60.0',
    IN_TEMPKLASSE: '',
    IN_ZONE: 'without (Safe Area)',
    DB_AUSFUEHRUNG_1LE1HK: 'Innomotics SD',
    SU_ST2RTDTORQUE_1LE1X: '3.20',
    SU_CONNECTION_1LE1X: 'D',
    SU_BRK2RTDTORQUE_1LE1X: '3.00',
    SU_CALCULATETORQUE_1LE1X: '1280.00',
    SU_PULLUPTORQUE_1010600: '2.30',
    SU_SPEEDPUTORQUERPM_1LE1HK: '1150',
    H_SU_UDELTA_1LE1HK: '400',
    SU_UY_1LE1HK: '690',
    SU_ST2RTDCURRENT_1LE1X: '7.40',
    SU_IDELTA_1LE1HK: '340.00',
    SU_IY_1LE1HK: '198.00',
    SU_I0DELTA_1LE1HK: '101.00',
    SU_I0Y_1LE1HK: '58.55',
    SU_INERTIATORQUE_1LE1X: '3.70000',
    SU_STARTUPTYPE_1LE1X: 'DOL',
    SU_TYPICALCURR_1LE1X: '340.00',
    SU_STARTUP_YD: 'yes',
    SU_VSD_DOL_TRIGGER_1LE1X: 'false',
    SU_VSD_VSD_TRIGGER_1LE1X: 'false',
    PMD_AAD450_001_000_HK1LE: '80',
    PMD_AAA136_001_000_HK1LE: 'IC411',
    SU_VSD_SPEED_1LE1X: '1487.64',
    SU_VSD_TORQUE_1LE1X: '1318.4',
    SU_VSD_FREQUENCY_1LE1X: '50'
};
